import MainLayout from "@/components/layout/admin/MainLayout.vue";
import {
    required,
    minLength,
    sameAs
} from "vuelidate/lib/validators";
import axios from "axios";
import store from "../../store";

export default {
    name: "changePassword",
    components: {
        MainLayout
    },

    data() {
        return {
            password: this.password,
            current_password: this.current_password,
            password_confirmation: this.password_confirmation,
            id: this.$route.params.id,
            submitted: false
        };
    },

    validations: {
        password: {
            required,
            minLength: minLength(6)
        },
        current_password: {
            required,
            minLength: minLength(6)
        },
        password_confirmation: {
            required,
            minLength: minLength(6),
            sameAsPassword: sameAs("password")
        }
    },

    methods: {
        handleSubmit() {
            this.submitted = true;
            if (this.$v.$invalid) {
                return;
            }
            this.changePassword();
        },

        changePassword() {
            var request = {
                password: this.password,
                current_password: this.current_password,
                id: this.id
            };
            axios.post("/admin/change_password/:id", request)
                .then(response => {
                    console.log("API Success", response.data);
                    store.commit("setAdminData", null);
                    this.$notification.success('Admin Change Password Successfully', {
                        timer: 3,
                        position: 'bottomCenter'
                    });
                    this.$router.push({
                        name: "adminLogin"
                    });
                })
                .catch(error => {
                    this.$notification.error("Confirm Current Password!", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    console.log("Change Password Client Error", error);
                });
        }
    }
};